import { OnlinePurchaseOrderFulfillmentTime } from "./OnlinePurchaseOrderFulfillmentTime";
import { QrWaiterPurchaseOrderFulfillmentTime } from "./QrWaiterPurchaseOrderFulfillmentTime";
export const PurchaseOrderFulfillmentTime = {
    create(params) {
        if (params.fulfillmentInstructions.type === "Online") {
            return new OnlinePurchaseOrderFulfillmentTime({
                restaurant: params.restaurant,
                payload: params.payload,
                fulfillmentInstructions: params.fulfillmentInstructions,
                now: params.now,
            });
        }
        else {
            return new QrWaiterPurchaseOrderFulfillmentTime();
        }
    },
};
